import React, { useState } from "react";
import AppointmentForm from "../../form/AppointmentForm";

const Service = ({ data, doctorName }) => {
  const {
    services_title,
    services_icon,
    services_list,
    expertise_title,
    expertise_icon,
    expertise_list,
  } = data;

  const webUrl = process.env.REACT_APP_WEB_URL;

  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <>
      <section className="dp-services-section py-5" data-sal="fade" data-sal-duration="300">
        <div className="container">
          <div className="row py-lg-5 justify-content-center" data-sal="slide-up" data-sal-duration="300">
            
            {services_list?.length > 0 && (
            <div className={`col-lg-6 ${expertise_list?.length > 0 ? '' : 'd-flex justify-content-center'}`} data-sal="fade">
              <div className="dp-services-wrapper">
                <div className="dp-s-heading">
                  {services_icon && (
                    <img
                      src={`${webUrl}${services_icon}`}
                      alt="icon"
                      className="img-fluid"
                    />
                  )}
                  <span>{services_title}</span>
                </div>
                <ul className="dp-s-items dp-s-border-right">
                  {services_list?.map((item, i) => (
                    <li key={i} data-sal="slide-up" data-sal-delay={300 + i * 50}>
                      {item.icon && (
                        <img
                          src={`${webUrl}${item.icon}`}
                          alt="point"
                          className="img-fluid"
                        />
                      )}
                      {item.text}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            )}

            {expertise_list?.length > 0 && (
            <div className={`col-lg-6 ps-lg-5 ${services_list?.length > 0 ? '' : 'd-flex justify-content-center'}`} data-sal="fade">
              <div className="dp-services-wrapper">
                <div className="dp-s-heading">
                  {expertise_icon && (
                    <img
                      src={`${webUrl}${expertise_icon}`}
                      alt="icon"
                      className="img-fluid"
                    />
                  )}
                  <span>{expertise_title}</span>
                </div>
                <ul className="dp-s-items">
                  {expertise_list?.map((item, i) => (
                    <li key={i} data-sal="slide-up" data-sal-delay={400 + i * 50}>
                      {item.icon && (
                        <img
                          src={`${webUrl}${item.icon}`}
                          alt="point"
                          className="img-fluid"
                        />
                      )}
                      {item.text}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            )}

            <div
              className="col-12 mt-5 text-center"
              data-sal="slide-down"
              data-sal-duration="300"
            >
              <button
                type="button"
                className="about-btn"
                onClick={openModal}
              >
                Book an Appointment
              </button>
            </div>
          </div>
        </div>
      </section>

      <AppointmentForm
        show={showModal}
        handleClose={closeModal}
        doctorName={doctorName}
      />
    </>
  );
};

export default Service;
